import { render } from "./carousel-arrows.vue?vue&type=template&id=347acfbe"
import script from "./carousel-arrows.vue?vue&type=script&lang=js"
export * from "./carousel-arrows.vue?vue&type=script&lang=js"

import "./carousel-arrows.vue?vue&type=style&index=0&id=347acfbe&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__